import RunbookCollection from 'app/views/core/runbooks/RunbookCollection';

class RunbookStore {
  collection = new RunbookCollection();

  get baseUrl() {
    return '/v4/settings/kentik-ai/runbooks';
  }

  /**
   * Get runbooks for a policy - accepts policy object with ruleId and/or id
   * Automatically tries both ruleId and policyId to find matching runbooks
   *
   * @param {Object} policy - Policy model object with ruleId and/or id properties
   * @returns {Array} Array of runbook models
   */
  getRunbooksForPolicy(policy) {
    if (!policy) {
      return [];
    }

    // note: eventually can remove policyId check once all runbooks are re-save to use ruleId, but for now support both
    const { ruleId, id: policyId } = policy;

    // Try to get runbooks by ruleId first, fallback to policyId
    let runbooks = [];

    if (ruleId) {
      runbooks = this.collection.getRunbooksForResource('alert_policy', ruleId);
    }

    if (runbooks.length === 0 && policyId && policyId !== ruleId) {
      runbooks = this.collection.getRunbooksForResource('alert_policy', policyId);
    }

    return runbooks;
  }
}

export default new RunbookStore();
